import { render, staticRenderFns } from "./Wiki.vue?vue&type=template&id=0fb4bf0d"
import script from "./Wiki.vue?vue&type=script&lang=js"
export * from "./Wiki.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports